'use strict';

export let BuscarArticuloRouteComponent = {
    selector     : 'buscarArticuloRoute', template: require('./buscar-articulo-route.html'), bindings: {
        articulos: '<', subcategorias: '<'
    }, controller: class {

        subcategoriaSeleccionada = null;

        /*@ngInject*/
        constructor($route, $scope, $window, $location) {
            Object.assign(this, {$route, $scope, $window, $location});

            $scope.$on('setPageTo', (ev, page) => {
                this.currentPage = page;
                this.pageReload();
            });
        }

        $onInit() {
            if (this.$route.current.params.categoria) {
                this.subItem = this.$route.current.params.categoria + ' / ' + this.$route.current.params.subcategoria;
                this.subcategorias.forEach(item => {
                    if (item.subcategoria.toUpperCase() === this.$route.current.params.subcategoria) {
                        this.subcategoriaSeleccionada = item;
                    }
                });
            } else if (this.$route.current.params.codigo) {
                this.subItem = this.$route.current.params.codigo;
            } else if (this.$route.current.params.palabra) {
                this.subItem = this.$route.current.params.palabra;
            }

            this.currentPage = 1;
            this.perPage = 20;
            this.totalPages = Math.ceil(this.articulos.length / this.perPage);
            this.pageReload();
            this.$window.scrollTo(0, 0);

        }

        pageReload() {

            let inicio = this.currentPage * this.perPage - this.perPage;
            let fin = this.currentPage * this.perPage;
            this.articulosPaginados = this.articulos.slice(inicio, fin);
            this.$window.scrollTo(0, 0);
        }


        buscarPorCategoria() {
            if (!this.subcategoriaSeleccionada)
                return;
            if(this.$route.current.params.subcategoria) {
                let arr = this.$location.path().split('/');
                arr[arr.length - 1] = this.subcategoriaSeleccionada.subcategoria.toUpperCase();
                this.$location.path(arr.join('/'));
            } else {
                this.$location.path(this.$location.path() + '/' + this.subcategoriaSeleccionada.subcategoria.toUpperCase());
            }

        }
    }
};



// WEBPACK FOOTER //
// ./client/app/buscar-articulo-route/buscar-articulo-route.component.js